const STORAGE_KEY = 'honouredtech_interests';

const readStoredInterests = () => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);
    if (!rawValue) {
      return [];
    }

    const parsedValue = JSON.parse(rawValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error('Failed to read saved interests:', error);
    return [];
  }
};

const writeStoredInterests = (items) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
};

const createLocalInterestRecord = (formData) => ({
  _id: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  companyName: formData.companyName,
  contactPerson: formData.contactPerson,
  mobileNumber: formData.mobileNumber,
  comments: formData.comments || '',
  myComments: [],
  interestLevel: '',
  createdAt: new Date().toISOString(),
  isLocalOnly: true,
});

export const getStoredInterests = () =>
  readStoredInterests().sort(
    (firstItem, secondItem) => new Date(secondItem.createdAt) - new Date(firstItem.createdAt)
  );

export const saveInterestLocally = (formData) => {
  const items = readStoredInterests();
  const newItem = createLocalInterestRecord(formData);
  writeStoredInterests([newItem, ...items]);
  return newItem;
};

export const deleteStoredInterest = (id) => {
  const nextItems = readStoredInterests().filter((item) => item._id !== id);
  writeStoredInterests(nextItems);
  return nextItems;
};

export const updateStoredInterest = (id, updates) => {
  const nextItems = readStoredInterests().map((item) => {
    if (item._id !== id) {
      return item;
    }

    const nextComments = Array.isArray(item.myComments) ? [...item.myComments] : [];
    if (typeof updates.myComment === 'string' && updates.myComment.trim()) {
      nextComments.push(updates.myComment.trim());
    }

    return {
      ...item,
      myComments: nextComments,
      interestLevel:
        typeof updates.interestLevel === 'string' && updates.interestLevel.trim()
          ? updates.interestLevel.trim()
          : item.interestLevel || '',
    };
  });

  writeStoredInterests(nextItems);
  return nextItems.find((item) => item._id === id) || null;
};
